import ServiceLocator from 'live/services/service-locator'
import PressureTestsUtils from 'plugin-pressuretests/shared/pressure_tests/pressure_tests_utils'
import htmlExportUtil from './htmlExportUtil'
import { TestOption, TypeCallbackExportError } from '../types'
import React from 'react'
import api from '../api'
import PressureTestCorrelatedTestComponent from '../componnents/pressuretest-correlated-test'
import LotFitCorrelatedTestComponent from '../componnents/lotfit-correlated-test'
import { LotFitAnnotation } from 'plugin-pressuretests/webapp/js/types/LotFit'
import _ from 'lodash'

interface TypeSispPayload {
    testId: string
    createdAt: number
    begin: number
    end: number
    wellId: string
    wellboreId: string
    testSISPId: string
    eventId: string
    testGroup?: string
    [k: string]: string | boolean | number | Record<string, unknown>
}
export type DataSendTestType = {
    result: string
    message: string
}
export const sispTestPayloadBuilder = async (
    type: string,
    test: TestOption,
    listCorrelatedTestsRef: React.MutableRefObject<HTMLDivElement>,
    defaultFields = {},
    callbackExportError: TypeCallbackExportError
): Promise<Record<string, unknown>> => {
    try {
        const testPayloadData = await parserBySource[type].getPayload?.(
            type,
            test,
            listCorrelatedTestsRef,
            callbackExportError
        )
        const results = sispTestResultBuilder(type, test.data)
        const payload = Object.assign({}, testPayloadData, results, defaultFields)

        return payload
    } catch (error) {
        callbackExportError({ error: 'Error in sipTestPayloadBuilder' })
    }
}

export const sispTestResultBuilder = (type: string, test: TestAnnotation): Record<string, unknown> => {
    return test?.__src ? parserBySource[type].getResults?.(test) : null
}

export const getCorrelatedTestsBySource = (
    test: TestAnnotation,
    count: number,
    end: number,
    filterByName: string,
    filterByAuthor: boolean,
    callback: { ({ data }: { data: unknown }): void; (response: { data: TestOption[] }): void },
    emptyCallback?: () => void
): void => {
    if (
        Object.keys(parserBySource).includes(test.__src) &&
        Object.keys(parserBySource[test.__src]).includes('getCorrelatedTests')
    ) {
        parserBySource[test.__src].getCorrelatedTests(test, count, end, filterByName, filterByAuthor, callback)
    } else {
        emptyCallback?.()
    }
}

export const setAditionalInformationBySource = (
    __src: string,
    test: TestAnnotation,
    callbackError: TypeCallbackExportError,
    groupIdValue: string
): unknown => parserBySource[__src].setAditionalInformation(test, callbackError, groupIdValue)

export const getCorrelatedTestsComponnentBySource = (
    __src: string,
    key: string,
    _test: TestOption,
    updateGetCharts: (fn: unknown) => void,
    updateGetAllChartTitles: (fn: unknown) => void
): React.ReactNode =>
    parserBySource[__src].getCorrelatedTestComponnent(
        key,
        _test,
        updateGetCharts || null,
        updateGetAllChartTitles || null
    )

export const getTestNameBySource = (__src: string, test: TestAnnotation): string =>
    parserBySource[__src].getTestName(test)

export const sendTestToSispBySource = (
    __src: string,
    test: TestAnnotation,
    instanceName: string,
    payload: TypeSispPayload,
    testGroup: string,
    callBack: () => void,
    callbackError: (e: unknown, msg?: string) => void
): void => parserBySource[__src]?.sendTest(test, instanceName, payload, testGroup, callBack, callbackError)

type TypeParser = {
    [__src: string]: {
        getTestName?: (test: TestAnnotation) => string
        getPayload?: (
            type: string,
            testOption: TestOption,
            listCorrelatedTestsRef: React.MutableRefObject<HTMLDivElement>,
            callbackExportError: TypeCallbackExportError
        ) => Promise<Record<string, unknown>>
        getResults?: (_test: TestAnnotation) => Record<string, unknown>
        getCorrelatedTests?: (
            test: TestAnnotation,
            count: number,
            end: number,
            filterByName: string,
            filterByAuthor: boolean,
            callback: (response: { data: TestOption[] }) => void
        ) => void
        getCorrelatedTestComponnent?: (
            key: string,
            testOption: TestOption,
            updateGetCharts: unknown,
            updateGetAllChartTitles: unknown
        ) => React.ReactNode
        setAditionalInformation: (
            test: TestAnnotation,
            callbackError: TypeCallbackExportError,
            groupIdValue?: string
        ) => unknown
        sendTest?: (
            test: TestAnnotation,
            instanceName: string,
            payload: TypeSispPayload,
            testGroup: string,
            callBack: (data: DataSendTestType) => void,
            callbackError: (e: unknown, msg: string) => void
        ) => void
        getSISPId: () => string
    }
}

const parserBySource: TypeParser = {
    'pressure-test': {
        getTestName: (test: PressureTestAnnotation) => test?.extra?.options?.config?.name,
        getPayload: async (
            type,
            _test: TestOption<PressureTestAnnotation>,
            listCorrelatedTestsRef,
            callbackExportError
        ) => {
            const charts = _test.getCharts()
            const curveChart = charts.curveChart
            const originalChart = charts.originalChart
            const testInfo =
                (_test.testInfo ||
                    listCorrelatedTestsRef.current
                        ?.getElementsByClassName(_test.data.uid)?.[0]
                        ?.getElementsByClassName('test-info')[0]) as HTMLDivElement


            const allChartTitles = _test.getAllChartTitles()
            const dropRateChart = charts.dropRateChart
            const smoothCurveOnly = charts.smoothCurveOnly

            let cloneTestInfo = null


            try {

                
                cloneTestInfo = testInfo.cloneNode(true) as HTMLDivElement
                cloneTestInfo.style.width = '835px'
            } catch (error) {
                console.log({ "Resize TestInfo Error":error });

            }


            try {
                const [
                    chartImageBase64,
                    originalChartBase64,
                    testInfoBase64,
                    dropRateChartBase64,
                    smoothCurveOnlyBase64,
                    curveChartTitle,
                    dropRateChartTitle,
                    originalChartTitle,
                    smoothCurveOnlyTitle
                ]: any = await Promise.all([
                    getBase64(curveChart?.querySelector?.('div > svg'), 381, 400),
                    getBase64(originalChart ? originalChart.querySelector?.('div > svg') : null, 381, 400),
                    exportHtmlAs(cloneTestInfo, 'PNG'),
                    getBase64(dropRateChart?.querySelector?.('div > svg'), 381, 400),
                    getBase64(smoothCurveOnly?.querySelector?.('div > svg'), 381, 400),
                    exportHtmlAs(allChartTitles.curveChartTitle, 'PNG'),
                    exportHtmlAs(allChartTitles.dropRateChartTitle, 'PNG'),
                    exportHtmlAs(allChartTitles.originalChartTitle, 'PNG'),
                    exportHtmlAs(allChartTitles.smoothCurveOnlyTitle, 'PNG')
                ])

                return {
                    createdAt: _test.data.createdAt,
                    begin: _test.data.begin,
                    end: _test.data.end,
                    chartImageBase64: htmlExportUtil.sanitizeBase64(chartImageBase64),
                    originalChartImageBase64: htmlExportUtil.sanitizeBase64(originalChartBase64),
                    testInfoImageBase64: htmlExportUtil.sanitizeBase64(testInfoBase64),
                    dropRateChartBase64: htmlExportUtil.sanitizeBase64(dropRateChartBase64),
                    smoothCurveOnlyBase64: htmlExportUtil.sanitizeBase64(smoothCurveOnlyBase64),
                    curveChartTitle: htmlExportUtil.sanitizeBase64(curveChartTitle),
                    dropRateChartTitle: htmlExportUtil.sanitizeBase64(dropRateChartTitle),
                    originalChartTitle: htmlExportUtil.sanitizeBase64(originalChartTitle),
                    smoothCurveOnlyTitle: htmlExportUtil.sanitizeBase64(smoothCurveOnlyTitle),
                    angularCoefficient: _test.data.extra.angularCoefficient,
                    linearCoefficient: _test.data.extra.linearCoefficient
                }
            } catch (error) {
                callbackExportError(error, 'Erron in pressuretest->getPayload')
            }
        },
        getResults: _test => {
            return {
                begin: _test.begin,
                end: _test.end,
                name: _test.extra.options.config.name,
                fittingType: PressureTestsUtils.getFittingType(_test.extra.options.config.fittingType),
                description: _test.extra.options.config.description,
                curve: _test.extra.options.curve,
                result: _test.extra.result,
                varitation: _test.extra.variation,
                variationTolerance: _test.extra.options.config.variationTolerance,
                minimumPressureLimit: _test.extra.options.minimumPressureLimit,
                maximumPressureLimit: _test.extra.options.maximumPressureLimit,
                beginToEndVariationTolerance: _test.extra.options.config.beginToEndVariationTolerance,
                checkMaxPercentVariation: _test.extra.options.config.checkMaxPercentVariation,
                dropRateLastValueTolerance: _test.extra.options.config.dropRateLastValueTolerance,
                angularCoefficient: _test.extra.angularCoefficient,
                linearCoefficient: _test.extra.linearCoefficient
            }
        },
        getCorrelatedTests: (test: PressureTestAnnotation, count, end, filterByName, filterByAuthor, callback) => {
            const origin = test?.extra?.options?.widgetId
            api.getTestsByWidgetId(origin, count, end, filterByName, filterByAuthor, callback)
        },
        getCorrelatedTestComponnent: function Component(
            key,
            _test,
            updateGetCharts,
            updateGetAllChartTitles
        ): JSX.Element {
            return (
                <PressureTestCorrelatedTestComponent
                    testOption={_test}
                    key={key}
                    updateGetCharts={updateGetCharts}
                    updateGetAllChartTitles={updateGetAllChartTitles}
                />
            )
        },
        setAditionalInformation: (test, callbackError, groupIdValue) => {
            api.setAditionalInformation(
                {
                    ...test,
                    extra: {
                        ...test.extra,
                        extra: {
                            testGroup: groupIdValue
                        }
                    }
                },
                () => ({}),
                e => callbackError(e, 'Origin: utils.js ->parserBySource.pressure-test.setAditionalInformation')
            )
        },
        sendTest: (test, instanceName, payload, testGroup, callBack, callbackError) => {
            api.send(
                instanceName,
                payload,
                ({ data }: { data: DataSendTestType }) => {
                    setAditionalInformationBySource('pressure-test', test, callbackError, testGroup)
                    callBack(data)
                },
                (e: unknown) => callbackError(e, 'Origin: utils.js ->parserBySource.pressure-test.sendTest')
            )
        },
        getSISPId: () => '297'
    },
    lotfit: {
        getTestName: (test: LotFitAnnotation) => test?.extra?.params?.testType.toLocaleUpperCase(),
        getPayload: async (type, _test: TestOption<LotFitAnnotation>, listCorrelatedTestsRef, callbackExportError) => {
            const charts = _test.getCharts()

            const chart = charts.chart
            const table = charts.table
            const testInfo = charts.testInfo

            try {
                const [chartImage, testInfoImageBase64, tableImageBase64]: any = await Promise.all([
                    getBase64(chart?.querySelector?.('svg'), 400, 400),
                    exportHtmlAs(testInfo, 'PNG'),
                    exportHtmlAs(table, 'PNG')
                ])
                const payload = {
                    testId: _test.data.testId,
                    createdAt: _test.data.createdAt,
                    begin: _test.data.begin,
                    end: _test.data.end,
                    wellId: _test.data.wellId,
                    testSISPId: _test.data.testSISPId,
                    wellboreId: _test.data.wellboreId,
                    eventId: _test.data.eventId,
                    chartImageBase64: htmlExportUtil.sanitizeBase64(chartImage),
                    tableImageBase64: htmlExportUtil.sanitizeBase64(tableImageBase64),
                    testInfoImageBase64: htmlExportUtil.sanitizeBase64(testInfoImageBase64)
                }
                return payload
            } catch (error) {
                callbackExportError(error, 'Error in getPayload')
            }
        },
        getResults: (_test: LotFitAnnotation) => _.cloneDeep(_test.extra),
        getCorrelatedTests: (test, count, end, filterByName, filterByAuthor, callback) => {
            const origin = test?.extra?.params?.assetConfig?.assetId
            api.getTestsByAssetId(origin, count, end, filterByName, filterByAuthor, callback)
        },
        setAditionalInformation: (test, callbackError, groupIdValue) => {
            api.setLotFitAditionalInformation(
                {
                    ...test,
                    extra: {
                        ...test.extra,
                        extra: {
                            testGroup: groupIdValue
                        }
                    }
                },
                () => null,
                (e: any) => callbackError(e, 'Origin: utils.js ->parserBySource.lotfit.setAditionalInformation')
            )
        },
        getCorrelatedTestComponnent: function Component(
            key,
            testOption,
            updateGetCharts,
            updateGetAllChartTitles
        ): JSX.Element {
            return (
                <LotFitCorrelatedTestComponent
                    _test={testOption}
                    key={key}
                    updateGetCharts={updateGetCharts}
                    updateGetAllChartTitles={updateGetAllChartTitles}
                />
            )
        },
        sendTest: (test, instanceName, payload, testGroup, callBack, callbackError) => {
            api.sendLotFit(
                instanceName,
                payload,
                ({ data }: { data: DataSendTestType }) => {
                    setAditionalInformationBySource('lotfit', test, callbackError, testGroup)
                    callBack(data)
                },
                (e: unknown) => callbackError(e, 'Origin: utils.js ->parserBySource.lotfit.sendTest ')
            )
        },
        getSISPId: () => '406'
    },
    pressuretests: {
        getTestName: (test: PressureTestAnnotation) => test?.extra?.options?.config?.name,
        getPayload: async (
            type,
            _test: TestOption<PressureTestAnnotation>,
            listCorrelatedTestsRef,
            callbackExportError
        ) => {
            const charts = _test.getCharts()
            const curveChart = charts.curveChart
            const originalChart = charts.originalChart
            const testInfo =
                _test.testInfo ||
                listCorrelatedTestsRef.current
                    ?.getElementsByClassName(_test.data.uid)?.[0]
                    ?.getElementsByClassName('test-info')[0]
            const allChartTitles = _test.getAllChartTitles()
            const dropRateChart = charts.dropRateChart
            const smoothCurveOnly = charts.smoothCurveOnly
            try {
                const [
                    chartImageBase64,
                    originalChartBase64,
                    testInfoBase64,
                    dropRateChartBase64,
                    smoothCurveOnlyBase64,
                    curveChartTitle,
                    dropRateChartTitle,
                    originalChartTitle,
                    smoothCurveOnlyTitle
                ]: any = await Promise.all([
                    getBase64(curveChart?.querySelector?.('div > svg'), 381, 400),
                    getBase64(originalChart ? originalChart.querySelector?.('div > svg') : null, 381, 400),
                    exportHtmlAs(testInfo, 'PNG'),
                    getBase64(dropRateChart?.querySelector?.('div > svg'), 381, 400),
                    getBase64(smoothCurveOnly?.querySelector?.('div > svg'), 381, 400),
                    exportHtmlAs(allChartTitles.curveChartTitle, 'PNG'),
                    exportHtmlAs(allChartTitles.dropRateChartTitle, 'PNG'),
                    exportHtmlAs(allChartTitles.originalChartTitle, 'PNG'),
                    exportHtmlAs(allChartTitles.smoothCurveOnlyTitle, 'PNG')
                ])

                return {
                    createdAt: _test.data.createdAt,
                    begin: _test.data.begin,
                    end: _test.data.end,
                    chartImageBase64: htmlExportUtil.sanitizeBase64(chartImageBase64),
                    originalChartImageBase64: htmlExportUtil.sanitizeBase64(originalChartBase64),
                    testInfoImageBase64: htmlExportUtil.sanitizeBase64(testInfoBase64),
                    dropRateChartBase64: htmlExportUtil.sanitizeBase64(dropRateChartBase64),
                    smoothCurveOnlyBase64: htmlExportUtil.sanitizeBase64(smoothCurveOnlyBase64),
                    curveChartTitle: htmlExportUtil.sanitizeBase64(curveChartTitle),
                    dropRateChartTitle: htmlExportUtil.sanitizeBase64(dropRateChartTitle),
                    originalChartTitle: htmlExportUtil.sanitizeBase64(originalChartTitle),
                    smoothCurveOnlyTitle: htmlExportUtil.sanitizeBase64(smoothCurveOnlyTitle),
                    angularCoefficient: _test.data.extra.angularCoefficient,
                    linearCoefficient: _test.data.extra.linearCoefficient
                }
            } catch (error) {
                callbackExportError(error, 'Erron in pressuretest->getPayload')
            }
        },
        getResults: _test => {
            return {
                begin: _test.begin,
                end: _test.end,
                name: _test.extra.options.config.name,
                fittingType: PressureTestsUtils.getFittingType(_test.extra.options.config.fittingType),
                description: _test.extra.options.config.description,
                curve: _test.extra.options.curve,
                result: _test.extra.result,
                varitation: _test.extra.variation,
                variationTolerance: _test.extra.options.config.variationTolerance,
                minimumPressureLimit: _test.extra.options.minimumPressureLimit,
                maximumPressureLimit: _test.extra.options.maximumPressureLimit,
                beginToEndVariationTolerance: _test.extra.options.config.beginToEndVariationTolerance,
                checkMaxPercentVariation: _test.extra.options.config.checkMaxPercentVariation,
                dropRateLastValueTolerance: _test.extra.options.config.dropRateLastValueTolerance,
                angularCoefficient: _test.extra.angularCoefficient,
                linearCoefficient: _test.extra.linearCoefficient
            }
        },
        getCorrelatedTests: (test: PressureTestAnnotation, count, end, filterByName, filterByAuthor, callback) => {
            const origin = test?.extra?.options?.widgetId
            api.getTestsByWidgetId(origin, count, end, filterByName, filterByAuthor, callback)
        },
        getCorrelatedTestComponnent: function Component(
            key,
            _test,
            updateGetCharts,
            updateGetAllChartTitles
        ): JSX.Element {
            return (
                <PressureTestCorrelatedTestComponent
                    testOption={_test}
                    key={key}
                    updateGetCharts={updateGetCharts}
                    updateGetAllChartTitles={updateGetAllChartTitles}
                />
            )
        },
        setAditionalInformation: (test, callbackError, groupIdValue) => {
            api.setAditionalInformation(
                {
                    ...test,
                    extra: {
                        ...test.extra,
                        extra: {
                            testGroup: groupIdValue
                        }
                    }
                },
                () => ({}),
                e => callbackError(e, 'Origin: utils.js ->parserBySource.pressure-test.setAditionalInformation')
            )
        },
        sendTest: (test, instanceName, payload, testGroup, callBack, callbackError) => {
            api.send(
                instanceName,
                payload,
                ({ data }: { data: DataSendTestType }) => {
                    setAditionalInformationBySource('pressure-test', test, callbackError, testGroup)
                    callBack(data)
                },
                (e: unknown) => callbackError(e, 'Origin: utils.js ->parserBySource.pressure-test.sendTest')
            )
        },
        getSISPId: () => '297'
    }
}

const exportHtmlAs = (testInfo: unknown, format = 'PNG'): Promise<string> => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    return new Promise((resolve, reject) => {

        testInfo = testInfo


        ServiceLocator.getService('export-html-as').then(exporthtml => {
            exporthtml(
                testInfo,
                format,
                'IMAGE',
                'name.png',
                (err: unknown, data: Blob | string) => {
                    if (err && !data) {

                        console.error(data)
                        return reject(data)
                    }

                    if (typeof data === 'string') return resolve(data?.replace(/^data:octet\/stream;base64,/, ''))

                    const reader = new FileReader()

                    reader.readAsDataURL(data)
                    reader.onloadend = function () {
                        resolve(_.toString(reader.result)?.replace(/^data:octet\/stream;base64,/, ''))
                    }
                },
                false,
                false,
                true
            )
        })
    })
}

const getBase64 = (svg: SVGElement, width: number, height: number): Promise<string | null> => {
    if (!svg) {
        return new Promise(resolve => {
            resolve(null)
        })
    }

    const svgData = new XMLSerializer().serializeToString(svg)
    const canvas = document.createElement('canvas')
    // eslint-disable-next-line no-useless-escape
    const imageWidth = width || svgData.match(/^<svg[^>]*width\s*=\s*\"?(\d+)\"?[^>]*>/)?.[1]
    // eslint-disable-next-line no-useless-escape
    const imageHeight = height || svgData.match(/^<svg[^>]*height\s*=\s*\"?(\d+)\"?[^>]*>/)?.[1]

    canvas.width = imageWidth as number
    canvas.height = imageHeight as number
    const ctx = canvas.getContext('2d')

    const data = encodeURIComponent(svgData)
    const svgUrl = 'data:image/svg+xml;charset=UTF-8,' + data

    const image = new Image()

    image.src = svgUrl
    image.crossOrigin = 'anonymous'

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    return new Promise((resolve, reject) => {
        image.onload = () => {
            ctx?.drawImage(image, 0, 0, canvas.width, canvas.height)
            resolve(canvas.toDataURL('image/png'))
        }
    })
}

export const setParentStyleByClassName = (
    element: HTMLElement,
    _className: string,
    atribute: string,
    value: string,
    limit = 10
): void => {
    let parent = element.parentElement
    for (let i = 0; i < limit; i++) {
        if (parent && parent.classList.value.includes(_className)) {
            parent.style[atribute] = value

            break
        } else if (!parent) {
            break
        } else {
            parent = parent.parentElement
        }
    }
}

export const getTestSISPIdBySource = (__src: string): string => parserBySource[__src].getSISPId()
